<template>

	<v-snackbar
		top
		:color="notificationBar.type"
		v-model="notificationBar.show"
	>
		{{ notificationBar.message }}
		<v-btn text @click="notificationBar.show = false">
			Close
		</v-btn>
	</v-snackbar>

</template>

<script>

export default {
	name: 'WalletWatcher',
	props: {
		walletNotConnectedRedirect: {
			type: String,
			required: true
		},
		chainChangeRedirect: {
			type: String,
			required: true
		},
		accountChangeRedirect: {
			type: String,
			required: true
		},
	},
	data () {
		return {
			notificationBar: {
				show: false,
				type: 'error', // 'success', 'error'
				message: ''
			}
		}
	},
	computed: {
	},
	methods: {
		async init() {
			// console.log('WalletWatcher init')
			// console.log('here' + this.walletNotConnectedRedirect)
			if (!window.ethereum || !window.ethereum.selectedAddress) {
				console.log('wallet not connected.')
				this.redirectToPage(this.walletNotConnectedRedirect)
			}
			else {
				// console.log(window.ethereum)
				// Disable auto refresh on network change
				window.ethereum.autoRefreshOnNetworkChange = false

				const that = this
				window.ethereum.on('networkChanged', function (chainId) {
					console.log('Chain change detected.')
					// that.showNotification('error', 'network changing detected. Please log in again')
					that.redirectToPage(that.chainChangeRedirect)
				})
				window.ethereum.on('chainChanged', function (chainId) {
					console.log('Chain change detected.')
					// that.showNotification('error', 'network changing detected. Please log in again')
					that.redirectToPage(that.chainChangeRedirect)
				})
				window.ethereum.on('chainIdChanged', function (chainId) {
					console.log('Chain change detected.')
					// that.showNotification('error', 'network changing detected. Please log in again')
					that.redirectToPage(that.chainChangeRedirect)
				})
				window.ethereum.on('accountsChanged', function (accounts) {
					console.log('account change detected.')
					// that.showNotification('error', 'account changing detected. Please log in again')
					that.redirectToPage(that.accountChangeRedirect)
				})
			}
		},

		reloadPage () {
			this.changeDetected = false
			this.$router.go(this.$router.currentRoute)
		},

		redirectToPage (routeName) {
			// console.log(this.$router.currentRoute)
			console.log('redirecting from ' + this.$router.currentRoute.name + ' to ' + routeName)
			if (this.$router.currentRoute.name !== routeName) {
				this.$router.push({name: routeName})
			}
		},

		 showNotification(type, message) {
			this.notificationBar.message = message
			this.notificationBar.type = type   // 'success' or 'error'
			this.notificationBar.show = true
		}

	},
	created () {
		this.init()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
